/**
 * Catalog cards aligned with "Presentation AZ_.pptx" product list.
 * Premium / sum insured are numeric (AZN shown in UI formatter).
 */
export function getCatalogMockProducts() {
  const territories = [
    "Bakı və Abşeron",
    "Azərbaycan üzrə partnyor şəbəkəsi",
    "Korporativ partnyor klinikalar",
  ];

  const rows = [
    {
      prodName: "Fərdi şəxslər üçün proqram (Referans)",
      adminCharge: 20,
      productType: 1,
      premiumAmount: 100,
      sumInsured: 1000,
      includedServices: [
        "Təcili tibbi yardım (ildə 2 dəfə, Bakı/Abşeron)",
        "Həkim müayinələri (ildə 2 dəfə)",
        "Check-up paketi (ildə 1 dəfə)",
        "Laborator və funksional xidmətlərə 10% endirim",
      ],
      eligibility: "Hədəf qrup: fiziki şəxslər, 18-60 yaş.",
      paymentCondition: "Bir Kart və Tam Kart ilə 6 ayadək bölmək imkanı.",
      ineligibility: "Qeyri-partnyor filiallarda endirim tətbiq olunmaya bilər.",
    },
    {
      prodName: "Körpəm (Referans)",
      adminCharge: 35,
      productType: 1,
      premiumAmount: 395,
      sumInsured: 2000,
      includedServices: [
        "TTY (ildə 2 dəfə, Bakı/Abşeron)",
        "Patronaj pediatr müayinəsi (ayda 1 dəfə, ildə 12 dəfə)",
        "24/7 çağrı və koordinasiya mərkəzi",
        "Onlayn pediatr (iCheck)",
        "Rəqəmsal qeydiyyat və aylıq hesabat",
      ],
      eligibility: "Hədəf qrup: 0-1 yaş uşaqlar.",
      paymentCondition: "Bir Kart və Tam Kart ilə 6 ayadək bölmək imkanı.",
      ineligibility: "1 yaşdan yuxarı uşaqlara şamil edilmir.",
    },
    {
      prodName: "Körpəm+ (Referans)",
      adminCharge: 150,
      productType: 1,
      premiumAmount: 1485,
      sumInsured: 5000,
      includedServices: [
        "Körpəm paketindəki bütün xidmətlər",
        "Peyvənd təqvimi üzrə peyvəndlər",
        "İldə 5 onlayn konsultasiya",
        "Peyvənd/müayinə üçün SMS xatırlatmalar",
      ],
      eligibility: "Hədəf qrup: 0-1 yaş uşaqlar.",
      paymentCondition: "Bir Kart və Tam Kart ilə 6 ayadək bölmək imkanı.",
      ineligibility: "Peyvənd cədvəlindən kənar xidmətlər paketdən kənar hesablanır.",
    },
    {
      prodName: "Valideynim (Referans)",
      adminCharge: 57,
      productType: 1,
      premiumAmount: 570,
      sumInsured: 3000,
      includedServices: [
        "TTY (ildə 2 dəfə)",
        "Ümumi profilaktik tibbi müayinə (ildə 2 dəfə)",
        "Həkim təyinatı ilə əlavə analizlər",
        "24/7 çağrı mərkəzi və onlayn həkim",
      ],
      eligibility: "Hədəf qrup: 60+ fiziki şəxslər.",
      paymentCondition: "Bir Kart və Tam Kart ilə 6 ayadək bölmək imkanı.",
      ineligibility: "Yaş meyarından aşağı şəxslərə tətbiq olunmur.",
    },
    {
      prodName: "Onlayn həkim (Referans)",
      adminCharge: 20,
      productType: 1,
      premiumAmount: 155,
      sumInsured: 2000,
      includedServices: [
        "iCheck platformasında dar ixtisas konsultasiyaları",
        "Hər gün 09:00-20:00 xidmət",
        "Terapevt üçün 09:00-22:00 rejimi",
        "İldə 7 onlayn konsultasiya",
      ],
      eligibility: "Hədəf qrup: istənilən yaş qrupunda fiziki şəxslər.",
      paymentCondition: "Bir Kart və Tam Kart ilə 6 ayadək bölmək imkanı.",
      ineligibility: "Korporativ şərtlər ayrıca anderraytinq hesablaması ilə verilir.",
    },
    {
      prodName: "KASKO + Reabilitasiya",
      adminCharge: 20,
      productType: 1,
      premiumAmount: 20,
      sumInsured: 5000,
      includedServices: [
        "Yol-nəqliyyat hadisəsindən sonra reabilitasiya",
        "30 günədək reabilitasiya kursu",
        "Fizioterapiya, müalicəvi idman və masaj",
        "Müalicə həkimi təyinatı əsasında təminat",
      ],
      eligibility: "KASKO üzrə sığortalanmış fiziki şəxslər (VIP daxil).",
      paymentCondition: "KASKO sığorta haqqının üzərinə +20 AZN.",
      ineligibility: "Hadisə və müraciət KASKO müddəti xaricindədirsə təminat yoxdur.",
    },
    {
      prodName: "Tələbəm",
      adminCharge: 25,
      productType: 1,
      premiumAmount: 220,
      sumInsured: 5000,
      includedServices: [
        "24/7 TTY briqadası və tibbi evakuasiya",
        "Hospitalizasiya və stasionar müalicə",
        "Ambulator-poliklinik yardım",
        "Dərman çatdırılması xidməti",
      ],
      eligibility: "Hədəf qrup: tələbələr, 15-25 yaş.",
      paymentCondition: "Bir Kart və Tam Kart ilə 6 ayadək bölmək imkanı.",
      ineligibility: "Hospitalizasiya üzrə gözləmə müddəti: 30 gün.",
    },
    {
      prodName: "Fiziki şəxslər üçün proqram",
      adminCharge: 50,
      productType: 1,
      premiumAmount: 565,
      sumInsured: 3000,
      includedServices: [
        "24/7 TTY briqadası və ilkin diaqnostika",
        "Planlı və təcili hospitalizasiya",
        "Ambulator-poliklinik xidmətlər",
        "Dərmanların çatdırılması",
      ],
      eligibility: "Hədəf qrup: fiziki şəxslər, 18-60 yaş.",
      paymentCondition: "Bir Kart və Tam Kart ilə 6 ayadək bölmək imkanı.",
      ineligibility: "Françiza: 30% (paket şərtlərinə əsasən).",
    },
    {
      prodName: "Ailəm",
      adminCharge: 200,
      productType: 1,
      premiumAmount: 1900,
      sumInsured: 8000,
      includedServices: [
        "24/7 TTY briqadası və tibbi evakuasiya",
        "Hospitalizasiya və stasionar müalicə",
        "Ambulator-poliklinik yardım",
        "Dərman çatdırılması xidməti",
      ],
      eligibility: "Hədəf qrup: ailələr (valideynlər + 18 yaşa qədər uşaqlar).",
      paymentCondition: "Ailə üzrə vahid tarif, 6 ayadək bölmək imkanı.",
      ineligibility: "Françiza: 30% (paket şərtlərinə əsasən).",
    },
    {
      prodName: "Ambulance (yalnız korporativ)",
      adminCharge: 20,
      productType: 2,
      premiumAmount: 120,
      sumInsured: 2500,
      includedServices: [
        "24/7 təcili tibbi yardım",
        "Təcili hospitalizasiya və stasionar müalicə",
        "Diaqnostika və dərman təchizatı",
        "Dərmanların çatdırılması xidməti",
      ],
      eligibility: "Hədəf qrup: 18-65 yaş, yalnız korporativ müştərilər.",
      paymentCondition: "Bir Kart və Tam Kart ilə 6 ayadək bölmək imkanı.",
      ineligibility: "Fərdi müştərilərə tətbiq olunmur.",
    },
  ];

  const moreInfoBlurbs = [
    "Partnyor şəbəkə: əsas xidmət təminatçısı Referans klinikalar şəbəkəsidir. Bölgə və xidmət növündən asılı olaraq əvvəlcədən koordinasiya tələb oluna bilər.",
    "Sığorta şərtləri üzrə limitlər və istisnalar müqavilənin ayrılmaz hissəsidir. Müqavilədə göstərilən xidmət həcmi əsas götürülür.",
    "Bəzi paketlərdə françiza (20% və ya 30%) tətbiq olunur. Françiza dərəcəsi seçilən proqrama görə fərqlənir.",
    "Korporativ paketlər üzrə fərdi hesablanma və anderraytinq tələbləri ayrıca təqdim edilə bilər.",
    "Onlayn xidmətlər iCheck platforması üzərindən göstərilir; xidmət saatları paket üzrə dəyişə bilər.",
  ];

  return rows.map((r, i) => ({
    _isMock: true,
    productId: 90001 + i,
    prodName: r.prodName,
    productType: r.productType,
    adminCharge: r.adminCharge,
    premiumAmount: r.premiumAmount,
    sumInsured: r.sumInsured,
    includedServices: r.includedServices,
    coverageTerritory: territories[i % territories.length],
    eligibility: r.eligibility,
    paymentCondition: r.paymentCondition,
    ineligibility: r.ineligibility,
    catalogMoreInfo: moreInfoBlurbs[i % moreInfoBlurbs.length],
  }));
}
